import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import { appConfig } from '../../../../config';
import { EndpointFundsPrices,EndpointFundsPricesFiltered,FundsPrices,FundsPricesEndpoint } from '../domain/FundsPrices.model';
import { createAdapterEndpointToFundsPrices, createAdapterToFundsPricesEndpoint, createAdapterToFieldFundsPricesEndpoint } from '../adapters/fundsPrices.adapter';
import { TableOptions } from '../../../../shared-kernel/components/Table';
import { createAdapterToFilterBackend } from '../../../../utilities/paramsAdapter';
import { FCIPriceItem } from '../domain/FundsPricesImport.model';
import { createAdapterFromFCIPriceToEndpoint } from '../adapters/fundsPricesImport.adapter';

const BASE_FUNDPRICE_URL = '/entidadesfinancieras/preciosfondos'
const BASE_FUNDPRICE_MUTATION_URL = '/entidadesfinancieras/preciosfondos'
export const BASE_EXPORT_URL = `${appConfig.API_NODE_URL}/entidadesfinancieras/preciosfondos/export`;

export const fundsPricesApi = createApi({
    reducerPath: "fundsPricesApi",
    baseQuery: fetchBaseQuery({
        baseUrl: appConfig.API_NODE_URL,
        prepareHeaders: (headers: Headers) => {
            const APP_TOKEN = "app_token";
            const token = localStorage.getItem(APP_TOKEN)

            if(token){
                headers.set("authorization", `Bearer ${token}`)
            }

            return headers
        },
        credentials: "include"
    }),
    tagTypes: ["FundsPrices", "FundPrice"],
    endpoints: (builder) => ({
        getFundPrice: builder.query<FundsPrices, string | undefined>({
            query: (id) => `${BASE_FUNDPRICE_MUTATION_URL}/${id}`,
            transformResponse: (response: EndpointFundsPrices) => {
                return createAdapterEndpointToFundsPrices(response.Content)
            },
            providesTags: (_res, _err, id) => [{type: "FundPrice", id: id?.toString()}],
        }),
        getFundsPrices: builder.query<any, TableOptions<FundsPrices> | undefined>({
            query: (params: TableOptions<FundsPrices>) => {
                const { page, pageSize, order, search, filters } = params || {};
                const adaptersFilter = filters?.map( f => createAdapterToFilterBackend(f,createAdapterToFieldFundsPricesEndpoint));
                const serializedFilters = adaptersFilter ? JSON.stringify(adaptersFilter) : undefined;
                const serializedOrder = order ? JSON.stringify({field:createAdapterToFieldFundsPricesEndpoint(order.field), order:order.order}) : undefined;
                return {
                    url: `${BASE_FUNDPRICE_URL}/filtros`,
                    params: {
                        page: page ? page - 1 : 0,
                        pageSize,
                        order: serializedOrder,
                        search,
                        filters: serializedFilters
                    }
                }
            },
            providesTags: ["FundsPrices"],
            transformResponse: (response: EndpointFundsPricesFiltered, _meta, params: TableOptions<FundsPrices>) => {
                 const page = params?.page ?? 1;
                 const endpointResponse = response?.rows?.map((fundPrice: FundsPricesEndpoint) => 
                     createAdapterEndpointToFundsPrices(fundPrice)
                 );
                 return {
                     data: endpointResponse,
                     page,
                     total: response.total
                 };
            }
        }),
        createFundPrice: builder.mutation<any, FundsPrices>({
            query: (data) => ({
              url: `${BASE_FUNDPRICE_MUTATION_URL}`,
              method: "POST",
              body: {
                "Content": createAdapterToFundsPricesEndpoint(data)
              },
            }),
            invalidatesTags: ["FundsPrices"],
        }),
        createImportFundsPrices: builder.mutation<any, any>({
            query: (precios) => ({
                url: `${BASE_FUNDPRICE_MUTATION_URL}/import`,
                method: "POST",
                body: {
                    precios: precios.map((r: FCIPriceItem) => createAdapterFromFCIPriceToEndpoint(r))
                }
            }),
            invalidatesTags: ["FundsPrices"],
        }),
        updateFundPrice: builder.mutation<any, FundsPrices>({
            query: (data: FundsPrices) => ({
                    url: `${BASE_FUNDPRICE_MUTATION_URL}`,
                    method: "PUT",
                    body: {
                    "Content": createAdapterToFundsPricesEndpoint(data)
                    }
                }),
            invalidatesTags: (_res,_err, data: FundsPrices) => ["FundsPrices", {type: "FundsPrices", id: data?.fciPriceId}],
        }),
        deleteFundPrice: builder.mutation<void, string>({
            query: (id) => ({
              url: `${BASE_FUNDPRICE_MUTATION_URL}/${id}`,
              method: "DELETE",
            }),
            invalidatesTags: ["FundsPrices"],
        }),
    })
});

// CAMBIAR LOS ENDPOINTS HOOKS
export const {
    useGetFundPriceQuery,
    useGetFundsPricesQuery,
    useCreateFundPriceMutation,
    useCreateImportFundsPricesMutation,
    useUpdateFundPriceMutation,
    useDeleteFundPriceMutation
} = fundsPricesApi